import { createTheme } from "@mui/material/styles";

import { styled } from "@mui/system";
import "../globals.scss";
import { ChevronDown as KeyboardArrowDownIcon } from "lucide-react";

const StyledKeyboardArrowDownIcon = styled(KeyboardArrowDownIcon)(
  ({ theme }) => ({
    color: `${theme.palette.primary.main} !important`,
    fontSize: 14,
  })
);

export const lightTheme = createTheme({
  components: {
    // MuiAutocomplete: {
    //   defaultProps: {
    //     popupIcon: <StyledKeyboardArrowDownIcon />,
    //   },
    // },
    // MuiSelect: {
    //   defaultProps: {
    //     IconComponent: StyledKeyboardArrowDownIcon,
    //   },
    // },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            opacity: 1,
            boxShadow: "none",
          },
        },
        contained: {
          "&.Mui-disabled": {
            backgroundColor: "var(--cuo-bg-alt)",
            color: "var(--cuo-text-muted)",
          },
        },
        outlined: {
          "&.Mui-disabled": {
            backgroundColor: "#fff",
            color: "var(--cuo-text-muted)",
            borderColor: "var(--cuo-border-color)",
          },
        },
        text: {
          "&.Mui-disabled": {
            backgroundColor: "transparent",
            color: "var(--cuo-text-muted)",
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: "16px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "primary",
            borderWidth: "1px",
          },
        },
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: "hsl(var(--muted))",
        },
      },
    },
  },
  typography: {
    fontSize: 12,
    fontFamily: [
      "-apple-system",
      '"system-ui"',
      '"Segoe UI"',
      "Roboto",
      "Helvetica",
      "sans-serif",
    ].join(","),
    allVariants: {
      color: "#09090b",
    },
  },
  palette: {
    mode: "light",
    primary: {
      light: "#27272a",
      main: "#18181b",
    },
    secondary: {
      main: "#9B8DFF",
    },
    success: {
      main: "#23b92a",
    },
    text: {
      primary: "#09090b",
      disabled: "#595959",
    },
  },
});
